import type { Routes } from '@angular/router';

import { LoginComponent } from '@app/auth/components/login/login.component';
import { LogoutComponent } from '@app/auth/components/logout/logout.component';
import { OAuthConsentComponent } from '@app/auth/components/oauth-consent/oauth-consent.component';
import { SSOLoginComponent } from '@app/auth/components/sso-login/sso-login.component';
import { authGuard } from '@app/auth/guards/auth.guard';
import { redirectToHomeGuard } from '@app/auth/guards/redirect-to-home.guard';

export const authRoutes: Routes = [
    {
        path: 'oauth2/authorize',
        component: OAuthConsentComponent,
        data: {
            title: 'Authorize Application',
        },
        canActivate: [authGuard],
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            title: 'Login Page',
        },
        canActivate: [redirectToHomeGuard],
    },
    {
        path: 'sso-refresh',
        component: SSOLoginComponent,
        data: {
            title: 'SSO Login',
        },
    },
    {
        path: 'logout',
        component: LogoutComponent,
        data: {
            title: 'Logout Page',
        },
    },
];
